import { useMemo } from "react";

import { SportPlay } from "../../../../types";
import { useGetAllSeriesQuery } from "../../series-api";
import { useGetAllTeamsQuery } from "../../team-api";
import { useGetFilteredPlaysQuery } from "../play-api";
import { FieldSearch, GetPlayQueryParams, SortQuery } from "../types";
import { convertPlayPayloadToSportPlay } from "../utils/convert-play-payload-to-sport-play";

export interface UseGetPlayProps {
  page: number;
  pageSize: number;
  fieldSearch: FieldSearch[];
  sort?: SortQuery;
}

export interface useGetPlayReturn {
  isFetching: boolean;
  plays: SportPlay[];
  totalRows: number;
}

export const useGetPlays = ({ page, pageSize, fieldSearch, sort }: GetPlayQueryParams) => {
  const { data: teams, isSuccess: isTeamsLoaded } = useGetAllTeamsQuery();
  const { data: series, isSuccess: isSeriesLoaded } = useGetAllSeriesQuery();

  const { data: pagedData, ...restUseGetFilteredPlaysQueryResp } = useGetFilteredPlaysQuery({
    page,
    pageSize,
    fieldSearch,
    sort: sort,
  });

  const convertedData = useMemo(
    () =>
      pagedData && isTeamsLoaded && isSeriesLoaded
        ? { ...pagedData, data: pagedData.data.map((play) => convertPlayPayloadToSportPlay({ play, teams, series })) }
        : undefined,
    [pagedData, isTeamsLoaded, isSeriesLoaded, teams, series]
  );

  return { data: convertedData, ...restUseGetFilteredPlaysQueryResp };
};
